import { HTTP as http } from "../../http";

const PREFIX = "/tell-me-when-arrive";

export default {
    getSessionEmail: () => {
        return http.get(PREFIX + "/getSessionEmail");
    },
    saveSubscribeTellMeWhenArrive: data => {
        return http.post(PREFIX + "/saveSubscribeTellMeWhenArrive", data);
    }
};
